"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sub = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Social = require("./Social");
require("./Sub.scss");
var Sub = function Sub(_ref) {
  var bar = _ref.bar,
    className = _ref.className,
    text = _ref.text;
  var Social = Sub.Social;
  var rootClassName = (0, _classnames["default"])('cds-FooterSub', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterSub-Content container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterSubGroup cds-FooterSubGroup--Note"
  }, text.copyright), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-FooterSubGroup cds-FooterSubGroup--Links"
  }, bar.links), /*#__PURE__*/_react["default"].createElement(Social, bar.social)));
};
exports.Sub = Sub;
Sub.Social = _Social.Social;